import { z } from 'zod';

export const useUserInfoValidation = () => {
	const userInfoSchema = z.object({
		id: z.number().optional(),
		email: z.string().trim().min(1),
		lastName: z.string().trim().min(1),
		firstName: z.string().trim().min(1),
		middleName: z.string().trim().min(1),
		region: z.string().trim().min(1),
		establishment: z.string().trim().min(1).optional(),
		specialty: z.string().trim().min(1),
		userAgreement: z.boolean().refine((val) => val === true),
		personalDataAgreement: z.boolean().refine((val) => val === true),
	});

	return { userInfoSchema };
};

export type UserInfo = z.infer<ReturnType<typeof useUserInfoValidation>['userInfoSchema']>;
